import {
    getBorder,
    getCssClasses,
    getIsHidden,
    getMargin,
    getPadding,
    getTextAlign
} from '../../utils'

const configAggregator = (node) => {
    const iframe = node.querySelector('iframe')
    const video = node.querySelector('video')
    const wrapper = node.querySelector('[data-element="wrapper"]')

    return {
        url:
            (iframe && iframe.getAttribute('src')) ||
            (video && video.getAttribute('src')) ||
            null,
        mobVideoURL: iframe
            ? iframe.getAttribute('data-mobile-video-source')
            : '',
        loop: iframe ? iframe.getAttribute('data-video-loop') : '',
        autoplay: video
            ? video.hasAttribute('autoplay')
            : !!(
                  iframe &&
                  /youtube|youtu\.be|vimeo/i.test(
                      iframe.getAttribute('src') || ''
                  ) &&
                  !/autoplay=(0|false)/i.test(iframe.getAttribute('src') || '')
              ),
        muted: !!(video && video.hasAttribute('muted')),
        maxWidth: node.childNodes[0].style.maxWidth || null,
        ...getTextAlign(node),
        ...getMargin(node),
        ...getBorder(wrapper),
        ...getPadding(wrapper),
        ...getCssClasses(node),
        ...getIsHidden(node)
    }
}

export default configAggregator
